import { Expose } from 'class-transformer';

export default class JobEmploymentCancelError {
    reason: string[] = []
    confirm_late_cancel: string[] = []
    late_fee_accepted: string[] = []
    @Expose({ name: '_schema' }) schema: string[] = []
}